import styled, { keyframes, css } from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const Header = styled.div`
  width: 100%;
  height: 64px;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;

  @media (max-width: 767px) {
    box-sizing: border-box;
    height: 64px;
    padding: 0 16px;
    border-bottom: 1px solid #ececf0;
  }
`;

export const HeaderLogo = styled.img`
  height: 32px;

  @media (max-width: 767px) {
    display: none;
  }
`;

export const HeaderTitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
`;

export const HeaderBackButton = styled.button`
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  background: transparent;
  color: #59249b;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;

  svg {
    width: 18px;
    height: 18px;
  }
`;

export const HeaderTitleIcon = styled.span`
  color: #59249b;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 22px;
    height: 22px;
  }
`;

export const HeaderTitle = styled.span`
  color: #393939;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const LogoutContext = styled.button`
  background: none;
  border: none;
  color: #aaadb1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  cursor: pointer;
  svg {
    fill: #aaadb1;
    width: 20px;
    height: 20px;
  }
`;

export const Content = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 1;

  @media (max-width: 767px) {
    box-sizing: border-box;
    width: 100%;
    padding: 20px 16px 24px;
    gap: 20px;
    min-width: 0;

    .ui.selection.dropdown {
      box-sizing: border-box;
      min-height: 48px;
      width: 100%;
      border: 1px solid #d8d8de;
      border-radius: 4px;
      box-shadow: none;
      display: flex;
      align-items: center;
      padding: 0 12px;
    }

    .ui.selection.dropdown > .text,
    .ui.selection.dropdown > .default.text {
      color: #393939;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .ui.selection.dropdown > .dropdown.icon {
      margin-left: auto;
    }
  }
`;

export const SubHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (max-width: 767px) {
    gap: 8px;
  }
`;

export const AnalysisTitle = styled.h2`
  font-weight: 600;
  font-size: 20px;
  color: #a3a3a3;
  margin: 0;
`;

export const CardHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const IconWrapper = styled.div`
  color: #59249b;
  font-size: 24px;
  display: flex;
  align-items: center;

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const CardTitle = styled.span`
  font-weight: 700;
  font-size: 26px;
  color: #393939;

  @media (max-width: 767px) {
    font-size: 22px;
    line-height: 28px;
  }
`;

export const Description = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #6b6f77;
  margin: 0;

  @media (max-width: 767px) {
    font-size: 13px;
    line-height: 18px;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const SectionTitle = styled.h3`
  font-weight: 600;
  font-size: 24px;
  color: #854ee0;
  margin: 0;
  white-space: nowrap;

  @media (max-width: 767px) {
    font-size: 20px;
  }
`;

export const Divider = styled.div`
  height: 1px;
  background-color: #854ee0;
  width: 100%;
`;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  @media (max-width: 767px) {
    gap: 14px;
    min-width: 0;
  }
`;

export const RadioGroup = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;

  @media (max-width: 767px) {
    gap: 8px;
    flex-wrap: wrap;
  }
`;

export const RadioButton = styled.div<{ active: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;
  padding: 12px 16px;
  gap: 10px;
  background: ${props => (props.active ? '#59249B' : '#FFFFFF')};
  border: 1px solid ${props => (props.active ? '#59249B' : '#DDDDDD')};
  border-radius: 6px;
  cursor: pointer;
  height: 48px;
  box-sizing: border-box;

  span {
    font-weight: 600;
    font-size: 16px;
    color: ${props => (props.active ? '#FFFFFF' : '#2B313C')};
  }
`;

export const CustomRadio = styled.div<{ active: boolean }>`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2px solid ${props => (props.active ? '#AC8AE4' : '#6B7280')};
  background: #ffffff;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  &::after {
    content: '';
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #59249b;
    display: ${props => (props.active ? 'block' : 'none')};
  }
`;

export const FooterButtons = styled.div`
  display: flex;
  gap: 24px;
  margin-top: 24px;

  @media (max-width: 767px) {
    gap: 12px;
    margin-top: 12px;
    width: 100%;

    > button {
      min-width: 0;
    }
  }
`;

export const buttonBaseStyles = css`
  flex: 1;
  height: 46px;
  border-radius: 4px;
  border: none;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }
`;

export const BackButton = styled.button`
  ${buttonBaseStyles}
  background: #6B7280;
  color: #ffffff;
`;

export const SubmitButton = styled.button`
  ${buttonBaseStyles}
  background: #59249B;
  color: #ffffff;
`;

// Loading Screen Styles
export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60vh;
  gap: 24px;
`;

export const LoadingText = styled.h3`
  font-weight: 600;
  font-size: 18px;
  color: #59249b;
`;

export const ProgressTrack = styled.div`
  width: 80%;
  height: 8px;
  background: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
`;

export const progressAnimation = keyframes`
  0% { width: 0%; }
  100% { width: 100%; }
`;

export const ProgressBar = styled.div`
  height: 100%;
  background: #59249b;
  animation: ${progressAnimation} 3s linear forwards;
`;

// Result Screen Styles
export const ResultCard = styled.div<{ expanded?: boolean }>`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 12px;
  gap: 16px;
  width: 100%;
  background: #ffffff;
  border: 1px solid #dddddd;
  border-radius: 8px;
  margin-bottom: 12px;

  @media (max-width: 767px) {
    padding: 14px;
    gap: 14px;
  }
`;

export const CardTopRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  width: 100%;
`;

export const InsurerLogo = styled.div<{ color: string }>`
  width: 65px;
  height: 65px;
  background-color: ${props => props.color};
  border-radius: 4px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  font-size: 24px;
`;

export const InsurerInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 7px;
  flex: 1;
`;

export const InsurerName = styled.span`
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #393939;
`;

export const StatusBadge = styled.div<{ type: 'approved' | 'rejected' }>`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 12px;
  gap: 8px;
  height: 27px;
  border: 1px solid #dddddd;
  border-radius: 16px;
`;

export const StatusDot = styled.div<{ type: 'approved' | 'rejected' }>`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: ${props => (props.type === 'approved' ? '#26FF26' : '#FF3B30')};
  border: 1px solid ${props => (props.type === 'approved' ? '#00F52D' : '#FF3B30')};
`;

export const StatusText = styled.span`
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  color: #393939;
`;

export const ExpandIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2b313c;
  cursor: pointer;
`;

export const DetailsRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: 16px;

  @media (max-width: 767px) {
    gap: 12px;
    flex-wrap: wrap;

    > * {
      min-width: 0;
    }
  }
`;

export const DetailColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const DetailLabel = styled.span`
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #808080;
`;

export const DetailValue = styled.span`
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #393939;
`;

export const ActionButtonsRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
`;

export const ValidateButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 16px;
  gap: 10px;
  flex: 1;
  height: 46px;
  background: #34c759;
  border-radius: 4px;
  border: none;
  font-weight: 600;
  font-size: 16px;
  color: #ffffff;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;

export const MyAnalysesButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 16px;
  gap: 10px;
  flex: 1;
  height: 46px;
  background: #59249b;
  border-radius: 4px;
  border: none;
  font-weight: 600;
  font-size: 16px;
  color: #ffffff;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;

export const ShareButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 16px;
  gap: 10px;
  width: 54px;
  height: 46px;
  background: #00a2dd;
  border-radius: 4px;
  border: none;
  color: #ffffff;
  font-size: 20px;
  cursor: pointer;
  &:hover {
    opacity: 0.9;
  }
`;

export const FinalBackButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 16px;
  gap: 10px;
  width: 100%;
  height: 46px;
  background: #6b7280;
  border-radius: 4px;
  border: none;
  font-weight: 600;
  font-size: 16px;
  color: #ffffff;
  cursor: pointer;
  margin-top: 12px;
  &:hover {
    opacity: 0.9;
  }
`;

// --- Validation Screen Styles ---
export const ValidationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: 767px) {
    gap: 16px;
    min-width: 0;
  }
`;

export const StepHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const StepperContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px;
`;

export const StepperVisual = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: center;
`;

export const StepperDot = styled.div<{ active?: boolean; finished?: boolean }>`
  width: 25px;
  height: 25px;
  box-sizing: border-box;
  background: ${props => (props.active ? '#59249B' : '#FFFFFF')};
  border: 1px solid ${props => (props.active ? '#59249B' : '#C8ACFD')};
  border-radius: 50%;
  z-index: 1;
`;

export const StepperLine = styled.div`
  width: 150px;
  height: 1px;
  background: #59249b;
  border: 1px solid #59249b;
`;

export const ValidateTitle = styled.div`
  width: 100%;
  padding: 4px 8px;
  border: 1px solid #dddddd;
  border-radius: 8px;
  display: flex;
  align-items: center;

  @media (max-width: 767px) {
    padding: 0 0 10px;
    border: none;
    border-bottom: 1px solid #854ee0;
    border-radius: 0;
  }

  span {
    font-weight: 600;
    font-size: 20px;
    color: #854ee0;
  }
`;

export const ValidationSectionTitle = styled.h4`
  font-weight: 400;
  font-size: 20px;
  color: #6b6f77;
  margin: 0;
  text-transform: uppercase;

  @media (max-width: 767px) {
    font-size: 18px;
    line-height: 24px;
  }
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;

  @media (max-width: 767px) {
    min-width: 0;

    .ui.selection.dropdown {
      box-sizing: border-box;
      min-height: 48px;
      width: 100%;
      border-radius: 4px;
      box-shadow: none;
    }
  }
`;

export const Row = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;

  @media (max-width: 767px) {
    flex-direction: column;
    gap: 12px;
  }
`;

export const ToggleInputContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border: 1px solid #dddddd;
  border-radius: 4px;
  padding: 0 10px;
  height: 42px;
  background: white;

  &.disabled {
    background: #e4e4e4;
  }
`;

export const StyledInput = styled.input`
  border: none;
  outline: none;
  width: 100%;
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  color: #393939;

  &::placeholder {
    color: rgba(57, 57, 57, 0.3);
  }

  &:disabled {
    background: transparent;
    color: #6b6f77;
  }
`;

export const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  color: #59249b;

  &:disabled {
    cursor: default;
    color: #999;
  }
`;
